import type { FieldErrors } from "react-hook-form";

import type { IKeyof } from "./typeTools";

import type { IOption } from "@/interfaces";
import { EmptyOption } from "@/interfaces";
import { notify } from "@components/organisms/notify";

export function showValidationErrors(errors: object) {
  const entries = Object.entries(errors);

  let errorsText = "";

  for (const [key, value] of entries) {
    if (value) {
      errorsText += key ? `${key}: ${value}.\n` : `${value}.\n`;
    }
  }

  notify.error({ title: errorsText });
}

export function clearFieldsDependencyValue<TFormik>(
  setFieldValue: (name: string, value: IOption) => void,
  dependencies: IKeyof<TFormik> | IKeyof<TFormik>[] | undefined,
) {
  // clear the dependency fields value
  if (dependencies === undefined) return;
  if (typeof dependencies === "string")
    setFieldValue(dependencies, EmptyOption);
  else {
    for (const dependencyFieldName of dependencies) {
      setFieldValue(dependencyFieldName, EmptyOption);
    }
  }
}

export function convertEmptyStringToNull(
  value: undefined | null | string,
): null | string {
  if (value === null || value === undefined || value || value.trim() === "") {
    return null;
  }
  return value;
}

export function isEmptyOption(value: IOption) {
  return value.key.toString().trim() === "";
}

export function extractReactFormErrorMessages<TSchema extends object = object>(
  errors: FieldErrors<TSchema>,
): Record<string, string> {
  const errorMessages: Record<string, string> = {};

  for (const key in errors) {
    if (Object.prototype.hasOwnProperty.call(errors, key)) {
      const element = errors[key as keyof typeof errors]?.message;

      if (element && typeof element === "string") {
        errorMessages[key] = element;
      }
    }
  }
  return errorMessages;
}
